module.exports = __webpack_public_path__ + "img/bell.5b4963db.svg";